<template>
  <NodeViewWrapper class="group/component my-4 rounded-2xl" :class="selected ? 'ring-2 ring-[#1c4848]/40' : ''">
    <component :is="view" :attrs="node.attrs" :read-only="!editor.isEditable" :context="editor.storage.writerContext" :set="updateAttributes" :kind="node.type.name" />
  </NodeViewWrapper>
</template>

<script setup>
import { computed } from 'vue';
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3';
import VerseFields from '@/components/writer/views/VerseFields.vue';
import HadithFields from '@/components/writer/views/HadithFields.vue';
import DuaFields from '@/components/writer/views/DuaFields.vue';
import OpinionFields from '@/components/writer/views/OpinionFields.vue';
import TermFields from '@/components/writer/views/TermFields.vue';
import TakeawaysFields from '@/components/writer/views/TakeawaysFields.vue';
import ListFields from '@/components/writer/views/ListFields.vue';
import QuizFields from '@/components/writer/views/QuizFields.vue';
import ImageFields from '@/components/writer/views/ImageFields.vue';
import GalleryFields from '@/components/writer/views/GalleryFields.vue';
import DividerFields from '@/components/writer/views/DividerFields.vue';
import CoverFields from '@/components/writer/views/CoverFields.vue';
import FeatureFields from '@/components/writer/views/FeatureFields.vue';
import ContentsFields from '@/components/writer/views/ContentsFields.vue';
import PullQuoteFields from '@/components/writer/views/PullQuoteFields.vue';
import StoryFields from '@/components/writer/views/StoryFields.vue';
import FactsFields from '@/components/writer/views/FactsFields.vue';
import TagsFields from '@/components/writer/views/TagsFields.vue';
import RailFields from '@/components/writer/views/RailFields.vue';
import CardFields from '@/components/writer/views/CardFields.vue';
import PinsFields from '@/components/writer/views/PinsFields.vue';

const VIEWS = {
  verse: VerseFields,
  hadith: HadithFields,
  dua: DuaFields,
  scholarOpinion: OpinionFields,
  term: TermFields,
  takeaways: TakeawaysFields,
  steps: ListFields,
  timeline: ListFields,
  qa: ListFields,
  quiz: QuizFields,
  image: ImageFields,
  gallery: GalleryFields,
  divider: DividerFields,
  cover: CoverFields,
  feature: FeatureFields,
  pullQuote: PullQuoteFields,
  contents: ContentsFields,
  story: StoryFields,
  facts: FactsFields,
  tags: TagsFields,
  rail: RailFields,
  heroNumber: CardFields,
  roundList: CardFields,
  checklist: CardFields,
  curve: CardFields,
  action: CardFields,
  spotlight: CardFields,
  statement: CardFields,
  deck: CardFields,
  pins: PinsFields,
};

const props = defineProps(nodeViewProps);
const view = computed(() => VIEWS[props.node.type.name]);
</script>
